(function () {
  'use strict';

  if (document.body && document.body.classList.contains('product-page')) return;

  var ready = false;
  var rerunTimer = 0;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function normalizeBadges(root) {
    root.querySelectorAll('.sale-badge, .product-badges__badge, .luscious-card__badge').forEach(function (badge) {
      var match = badge.textContent.replace(/\s+/g, ' ').trim().match(/(\d+)\s*%(?:\s*OFF)?/i);
      if (match) badge.textContent = match[1] + '% OFF';
    });
  }

  function initCarousel(scope) {
    if (scope.dataset.lusciousCarouselReady === 'true') return;
    var track = scope.querySelector('[data-luscious-track]');
    var prev = scope.querySelector('[data-luscious-prev]');
    var next = scope.querySelector('[data-luscious-next]');
    if (!track || !prev || !next) return;
    scope.dataset.lusciousCarouselReady = 'true';

    function step(direction) {
      var card = track.querySelector('.luscious-clean-carousel__item, .luscious-review-card');
      var width = card ? card.getBoundingClientRect().width : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * (width + parseFloat(getComputedStyle(track).gap || 0)), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
  }

  function initTabs(section) {
    if (section.dataset.lusciousTabsReady === 'true') return;
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-luscious-tab-button]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-luscious-tab-panel]'));
    if (!buttons.length || !panels.length) return;
    section.dataset.lusciousTabsReady = 'true';

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.dataset.target;
        buttons.forEach(function (item) {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.id !== id;
          panel.classList.toggle('is-active', panel.id === id);
        });
      });
    });
  }

  function init(root) {
    normalizeBadges(root);
    root.querySelectorAll('[data-luscious-carousel], .luscious-reviews__carousel').forEach(initCarousel);
    root.querySelectorAll('.luscious-clean-tabs').forEach(initTabs);
  }

  onReady(function () {
    if (ready) return;
    ready = true;
    init(document);
    [300, 1000, 2500].forEach(function (delay) {
      window.setTimeout(function () { init(document); }, delay);
    });
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        window.clearTimeout(rerunTimer);
        rerunTimer = window.setTimeout(function () { init(document); }, 120);
      }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    }
  });

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
